import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getList = data => {
  return axios.request({
    url: "/cost/deliver/index",
    method: "post",
    data
  });
};

export const Upload = (data) => {
  return axios.request({
    url: "/cost/deliver/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data: data,
  });
};


export const createBill = data => {
  return axios.request({
    url: "/cost/deliver/create_bill",
    method: "post",
    data
  });
};
